var map = {
	"./BG.png": 66204,
	"./cookie-icon.svg": 16180,
	"./dashboard-plataforma-mercatorio-1.png": 13576,
	"./dashboard-plataforma-mercatorio-2.png": 35388,
	"./favicon.ico": 96844,
	"./filter.svg": 43680,
	"./flower.svg": 3236,
	"./gold.jpg": 97740,
	"./info.svg": 24736,
	"./ir.png": 28372,
	"./lamp.svg": 88052,
	"./logo-blue-gray-side.png": 33816,
	"./logo-white.png": 38728,
	"./logo.png": 50104,
	"./logomercatoriobetabranco.png": 95012,
	"./mercatoriobeta.png": 37636,
	"./pig.svg": 74124,
	"./wallet.svg": 12140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44328;